import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ProductToStoragePlaceListWidgetComponent } from '../product-to-storage-place-link-list-widget/product-to-storage-place-link-list-widget.component';

@Component({
  selector: 'app-formly-product-to-storage-place-link-list-widget',
  templateUrl: './formly-product-to-storage-place-link-list-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ProductToStoragePlaceListWidgetComponent
  ]
})
export class FormlyProductToStoragePlaceLinkListWidgetComponent extends FieldType {

  constructor(
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }


  ngOnInit(): void {

    // this.getProductId();
    // this.formControl?.valueChanges.subscribe(x => {
    //   this.getProductId();
    // });
  }

}